import React from 'react';

import IntlMessages from '@iso/components/utility/intlMessages';
  
export const renderMessage = (status, updating) => {
    if(updating[status] === 'validating') return <IntlMessages id="forms.updating.inprogress" />
    if(updating[status]  === 'error') return <IntlMessages id="forms.updating.fail" />
    if(updating[status]  === 'success') return <IntlMessages id="forms.updating.success" />
}
